import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { v4 as uuidv4 } from 'uuid';

import {
  DataGridColSettings,
  mergeColumnSettings,
} from '@/components/DataGrid/utils';
import { Button } from '@/components/TailwindComponents';
import { LocalStoragePrefix } from '@/constants';
import { InmateDataGrid } from '@/pages/JMS/Managament/components/grids/InmateDataGrid';
import AddInmateNoteSidePanel from '@/pages/JMS/Managament/components/panels/AddInmateNoteSidePanel';
import { inmateDataGridColumns } from '@/pages/JMS/Managament/data/data';
import { IInmate } from '@/pages/JMS/Managament/types/inmate';
import { JmsManagementRoutes } from '@/pages/JMS/Managament/utils/utils';
import { useBookingStore } from '@/pages/JMS/store/BookingStore';
import { useUserStore } from '@/store';
import { getLocalStorageItem } from '@/utils';

const InmatesTab = () => {
  const navigate = useNavigate();
  const { user } = useUserStore();
  const { clearBooking } = useBookingStore();

  const [inmateId, setInmateId] = useState<string | undefined>(undefined);
  const [isPanelOpen, setIsPanelOpen] = useState<boolean>(false);

  const [columnSettings, setColumnSettings] = useState<DataGridColSettings[]>(
    () => {
      const savedSettings = getLocalStorageItem({
        key: String(user?._id),
        prefix: `inmate-${LocalStoragePrefix.TableSetting}`,
        shouldParse: true,
      });

      if (!savedSettings) {
        return inmateDataGridColumns;
      }

      return mergeColumnSettings(inmateDataGridColumns, savedSettings);
    },
  );

  const handleOpenPanel = (
    e: React.MouseEvent<HTMLButtonElement>,
    inmate?: IInmate,
  ) => {
    e.stopPropagation();
    setInmateId(inmate?._id);
    setIsPanelOpen(true);
  };

  return (
    <>
      <InmateDataGrid
        cta={
          <Button
            className="h-[38px]"
            onClick={() => {
              navigate(JmsManagementRoutes.SearchPerson);
              clearBooking();
            }}
          >
            Add New Booking
          </Button>
        }
        columnSettings={columnSettings}
        setColumnSettings={setColumnSettings}
        onOpenPanel={handleOpenPanel}
      />
      <AddInmateNoteSidePanel
        key={uuidv4()}
        inmateId={inmateId}
        isOpen={isPanelOpen}
        setIsOpen={setIsPanelOpen}
      />
    </>
  );
};

export default InmatesTab;
